import React from 'react';
import styles from './ConfirmDialog.module.scss';
import { Button } from '..';
import ScrollableContainer from '../ScrollableContainer';
import { StatusTypes } from "models";

const ConfirmDialog = props => {
  const {
    description,
    project,
    submitText,
    closeModal,
    onSubmit,
    republishProject,
  } = props;
  const handleSubmit = () => {
    onSubmit();
    closeModal();
  };

  const handleRepublish = () => {
    republishProject(project.id)
    closeModal()
  }

  return (
    <div>
      <ScrollableContainer className={styles.text}>
        {description}
      </ScrollableContainer>
      <div className={styles.buttonsContainer}>
        <Button
          type='cancel'
          size='mini'
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          size='mini'
          onClick={handleSubmit}
        >
          {submitText ?? 'Confirm'}
        </Button>
          {handleRepublish && project.status === StatusTypes.HAS_CHANGES && <Button
          type='submit'
          size='mini'
          onClick={handleRepublish}
        >
          Republish
        </Button>}
      </div>
    </div>
  );
};

export default ConfirmDialog;
